import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ModalBase from '@/components/modalBase/modalBase';
import { Action, Getter } from 'vuex-class';
import Loading from '@/components/loading/loading';

@Component({
  components: {
    ModalBase,
    Loading
  }
})
export default class ModalCashbackRequest extends Vue {

  // Properties
  @Prop({ default: false }) show;

  // Getters
  @Getter getCurrentOrder: any
  @Getter getCountry: any

  // Actions
  @Action action_returnProducts: any

  // Attributes
  availableProducts = [];
  requestedProducts = [];
  isTyC = false;
  showValidation = false;
  validationMessage = "";
  isLoading = false;
  feedbackMinLength = 100;

  mounted() {
    this.setAvailableProducts();
  }

  setAvailableProducts() {
    let response = [];
    if (
      this.getCurrentOrder &&
      this.getCurrentOrder.new_products &&
      this.getCurrentOrder.new_products.length &&
      this.getCurrentOrder.json_products &&
      this.getCurrentOrder.json_products.length
    ) {
      const newProductsIds = this.getCurrentOrder.new_products;
      const orderProducts = this.getCurrentOrder.json_products;
      orderProducts.map((product) => {
        const index = newProductsIds.findIndex((id) => id === product.product_id);
        if(index !== -1) {
          response.push({ product, selected: false, feedback: "" });
        }
      });
    }
    this.availableProducts = [...response];
    
  }

  get getSelectedProductsQuantity() {
    let response = 0;
    if(this.availableProducts && this.availableProducts.length) {
      this.availableProducts.forEach((item) => {
        if(item.selected) {
          response++;
        }
      });
    }
    return response;
  }

  _price(value) {
    let response = value;
    if(this.getCountry && this.getCountry.currency) {
      response = this.$currency.format(value, { code: this.getCountry.currency });
    }
    return response;
  }

  validate() {
    this.validationMessage = "";
    if(this.availableProducts && this.availableProducts.length) {
      const numProducts = this.getSelectedProductsQuantity;
      if(numProducts > 3) {
        this.validationMessage = "Máximo puedes pedir devolución de 3 productos";
      }
      if(numProducts < 1) {
        this.validationMessage = "Elige al menos 1 producto";
      }
      for (let i = 0; i < this.availableProducts.length; i++) {
        const item = this.availableProducts[i];
        if (item.selected && item.feedback.length < this.feedbackMinLength) {
          this.validationMessage = "El comentario de cada producto seleccionado " + 
          `debe ser de al menos ${this.feedbackMinLength} caracteres.`; 
        }
      }
    }
    return this.validationMessage;
  }

  async sendRequest() {
    this.isLoading = true;
    if(this.isTyC) {
      this.validate();
      if(this.validationMessage.length === 0) {
        const products = [];
        this.availableProducts.map((item) => {
          if (item && item.product && item.selected && item.feedback && item.feedback.length) {
            products.push({ product_id: item.product.product_id, feedback: item.feedback });
          }
        });
        const payload = {
          products: [...products],
          orderId: this.getCurrentOrder.id
        };
        try {
          const response = await this.action_returnProducts(payload);
          if (response) {
            this.$emit("close-modal");
            this.$router.go(0);
          } else {
            this.validationMessage = "¡Ups! Algo falló. Por favor, intenta de nuevo.";
            this.showValidation = true;
          }
        } catch (error) {
          let msg = "";
          if (error.response && error.response.data && error.response.data.message) {
            msg = "Error: " + error.response.data.message;
          }
          this.$swal({
            title: "Error",
            text:
              "¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo y si el error " +
              "persiste, comunícate con nosotros a través del chat" +
              " para completar tu solicitud manualmente." +
              msg
          });
        }
        
      } else {
        this.showValidation = true;
      }
    }
    this.isLoading = false;
  }

  @Watch('isTyC')
  onTyCChange() {
    if(!this.isTyC) {
      this.availableProducts.forEach((item) => {
        item.selected = false;
        item.feedback = "";
      });
    }
  }

  get isButtonEnabled() {
    let response = true;
    if(!this.getSelectedProductsQuantity || !this.isTyC) {
      response = false;
    }
    return response;
  }

  _openTyC() {
    window.open('/files/TYC_Atrevete_a_Probar.pdf');
  }


}